import { Typography } from '@euler/app/components/typography';
import { ApdmImportSummary } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { useTheme } from 'styled-components';
import { formatMonth } from '../../functions/formatMonth';

export function BusiestMonths({
  months,
}: {
  months: ApdmImportSummary['busiestMonths'];
}) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  if (!months.length) return null;
  return (
    <View style={{ marginTop: rpx(12) }}>
      <Typography.Text size={rpx(13)} bold color={theme.label.color}>
        来店最多的月份
      </Typography.Text>
      <Typography.Text size={rpx(13)} color={theme.label.color}>
        {months
          .map(entry => `${formatMonth(entry.month)} ${entry.visits} 次`)
          .join('，')}
      </Typography.Text>
    </View>
  );
}
